import * as tslib_1 from "tslib";
import CategoriesColumn from './CategoriesColumn';
import OptionsPane from './OptionsPane';
import OptionsPaneError from './OptionsPaneError';
import OptionsPaneLoading from './OptionsPaneLoading';
import SettingsFormHeader from './SettingsFormHeader';
import SubCategoriesColumn from './SubCategoriesColumn';
import { AnimationClassNames } from '@uifabric/styling';
import { observer } from 'mobx-react';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { hideFullOptions } from 'owa-options-orchestration';
import { getCurrentCategory, getCurrentSubcategory, getStore, getCurrentSubcategoryLoadState, } from 'owa-options-store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
var styles = require('./OptionsFull.scss');
var className = require('classnames/bind').bind(styles);
var OptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsFull, _super);
    function OptionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsFull.prototype.render = function () {
        var store = getStore();
        var subcategoriesForCategory = getCurrentCategory().subcategories;
        var selectedSubCategory = getCurrentSubcategory() || {};
        var options = selectedSubCategory.options || [];
        return (React.createElement(Modal, { isOpen: store.isFullOptionsShown, onDismiss: this.hide, containerClassName: className(store.isFullOptionsShown
                ? AnimationClassNames.slideUpIn20
                : AnimationClassNames.slideDownOut20, styles.modal) },
            React.createElement("div", { className: styles.container },
                React.createElement(CategoriesColumn, null),
                React.createElement(SubCategoriesColumn, { subcategories: subcategoriesForCategory }),
                React.createElement("div", { className: className(styles.settingsPane, AnimationClassNames.slideLeftIn20), key: store.currentSubCategoryKey },
                    React.createElement(SettingsFormHeader, { selectedSubCategory: selectedSubCategory }),
                    this.renderOptionsPane(options)))));
    };
    OptionsFull.prototype.hide = function () {
        hideFullOptions();
    };
    OptionsFull.prototype.renderOptionsPane = function (options) {
        switch (getCurrentSubcategoryLoadState()) {
            case 0 /* Loading */:
                return React.createElement(OptionsPaneLoading, null);
            case 1 /* Loaded */:
                return React.createElement(OptionsPane, { options: options });
            case 2 /* Error */:
            default:
                return React.createElement(OptionsPaneError, null);
        }
    };
    OptionsFull = tslib_1.__decorate([
        observer
    ], OptionsFull);
    return OptionsFull;
}(React.Component));
export default OptionsFull;
var optionsFullContainer;
export function mountOptionsFullPopup() {
    if (!optionsFullContainer) {
        optionsFullContainer = document.createElement('div');
        document.body.appendChild(optionsFullContainer);
        ReactDOM.render(React.createElement(OptionsFull, null), optionsFullContainer);
    }
}
//# sourceMappingURL=OptionsFull.js.map